import React from 'react';

export const PropertyCardPriceLink: React.FC<{
  testId: string;
  href: string;
  onClick: () => void;
  HQVRateBlockFlag?: boolean;
  pageVal?: string;
  clickTrackingLoc: string;
  children: React.ReactNode;
}> = ({ testId, href, onClick, HQVRateBlockFlag, pageVal, clickTrackingLoc, children }) => (
  <a
    {...(!HQVRateBlockFlag
      ? {
          className: 'analytics-click custom_click_track ',
        }
      : '')}
    {...(HQVRateBlockFlag ? { href: 'javascript:void(0)' } : { href })}
    onClick={onClick}
    data-testid={testId}
    target={pageVal === 'chat' && !HQVRateBlockFlag ? '_blank' : '_self'}
    rel={pageVal === 'chat' ? 'noreferrer' : undefined}
    {...{ custom_click_track_value: `${clickTrackingLoc}| Price |internal` }}
  >
    {children}
  </a>
);
